import React, { useEffect, useState } from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Card,
  Chip,
  Grid,
  IconButton,
  MenuItem,
  OutlinedInput,
  Select,
  Stack,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { employeePermissions, getRoleLabel } from '../../../utils/settings';
import {
  addRolePermissionAction,
  deleteEmployeeAction,
  updateUserInfoAction,
} from '../APIs/action';
import CheckIcon from '@mui/icons-material/Check';
import EditIcon from '@mui/icons-material/Edit';
import CloseIcon from '@mui/icons-material/Close';
import { toast } from 'react-toastify';

const EmployeeDetailCard = ({ data, key, onDelete }) => {
  const [employeeData, setEmployeeData] = useState(data);
  const [selectedRoles, setSelectedRoles] = useState(
    data?.employee_roles?.map((role) => role.label),
  );

  const [isEditing, setIsEditing] = useState(false);
  const onUpdateEmployeeDetails = async () => {
    const payload = {
      firstname: employeeData?.firstname,
      lastname: employeeData?.lastname,
      user_phone_number: employeeData?.phone_number,
    };

    const { error, message } = await updateUserInfoAction(payload);

    if (!error) {
      const payload = {
        user_id: employeeData.id,
        roles_name: selectedRoles,
        company_id: employeeData.firm_id,
      };

      const { error, message } = await addRolePermissionAction(payload);
      if (!error) {
        return toast.success('Employee Details updated successfully');
      } else {
        setSelectedRoles(data?.employee_roles?.map((role) => role.label));
        return toast.error(message);
      }
    } else {
      setEmployeeData(data);
      return toast.error(message);
    }
  };
  const handleEditClick = async () => {
    if (isEditing) {
      await onUpdateEmployeeDetails();
    }
    setIsEditing(!isEditing);
  };

  const handleDiscardClick = () => {
    setEmployeeData(data);
    setIsEditing(false);
  };
  return (
    <Accordion
      key={key}
      sx={{ borderRadius: 2,  }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        sx={{ py: 1 }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            width: '100%',
            justifyContent: 'space-between',
            mx: 2,
            
          }}
        >
          <Typography
            fontSize={'1rem'}
            fontWeight={'bold'}
          >
            {data.firstname} {data.lastname}
          </Typography>
          {employeeData?.is_admin && (
            <Typography
              fontSize={'1rem'}
              fontWeight={'bold'}
              sx={{ pl: 2 }}
            >
              Admin
            </Typography>
          )}
        </Box>
      </AccordionSummary>
      <AccordionDetails 
        sx={{ pl: '2rem' }}
      >
        {!employeeData?.is_admin && (
          <Stack direction={'row-reverse'}>
            <Stack
              direction='row'
              spacing={2}
              
            >
              <Tooltip title={isEditing ? 'Save' : 'Edit'}>
                <IconButton
                  color='primary'
                  onClick={handleEditClick}
                >
                  {isEditing ? (
                    <CheckIcon sx={{ color: 'green' }} />
                  ) : (
                    <EditIcon />
                  )}
                </IconButton>
              </Tooltip>
              {isEditing && (
                <Tooltip title='Discard'>
                  <IconButton
                    color='primary'
                    onClick={handleDiscardClick}
                  >
                    <CloseIcon sx={{ color: 'red' }} />
                  </IconButton>
                </Tooltip>
              )}
            </Stack>
          </Stack>
        )}

        <Grid container>
          <Grid
            item
            xs={4}
            md={3}
            alignContent='center'
          >
            <Typography
              variant='h6'
              fontSize={15}
            >
              First Name
            </Typography>
          </Grid>
          <Grid
            item
            xs={6}
            md={5}
            alignContent='center'
          >
            <TextField
              disabled={!isEditing}
              label='First Name'
              name='firstname'
              value={employeeData.firstname}
              onChange={(e) => {
                setEmployeeData({
                  ...employeeData,
                  firstname: e.target.value,
                });
              }}
              fullWidth
              margin='normal'
            />
          </Grid>
        </Grid>
        <Grid container>
          <Grid
            item
            xs={4}
            md={3}
            alignContent='center'
          >
            <Typography
              variant='h6'
              fontSize={15}
            >
              Last Name
            </Typography>
          </Grid>
          <Grid
            item
            xs={6}
            md={5}
            alignContent='center'
          >
            <TextField
              disabled={!isEditing}
              label='Last Name'
              name='firstname'
              value={employeeData.lastname}
              onChange={(e) => {
                setEmployeeData({
                  ...employeeData,
                  lastname: e.target.value,
                });
              }}
              fullWidth
              margin='normal'
            />
          </Grid>
        </Grid>
        <Grid container>
          <Grid
            item
            xs={4}
            md={3}
            alignContent='center'
          >
            <Typography
              variant='h6'
              fontSize={15}
            >
              Phone Number
            </Typography>
          </Grid>
          <Grid
            item
            xs={6}
            md={5}
            alignContent='center'
          >
            <TextField
              disabled={true}
              label='Phone Number'
              name='phone_number'
              value={employeeData.phone_number}
              //   onChange={handleChange}
              fullWidth
              margin='normal'
            />
          </Grid>
        </Grid>
        <Grid container>
          <Grid
            item
            xs={4}
            md={3}
            alignContent='center'
          >
            <Typography
              variant='h6'
              fontSize={15}
            >
              Employee Role
            </Typography>
          </Grid>
          <Grid
            item
            xs={6}
            md={5}
            alignContent='center'
          >
            <Select
              labelId='multiple-chip-label'
              id='multiple-chip'
              multiple
              value={selectedRoles}
              onChange={(e) => {
                setSelectedRoles(e.target.value);
              }}
              fullWidth
              disabled={!isEditing}
              input={
                <OutlinedInput
                  id='select-multiple-chip'
                  label='Employee Roles'
                />
              }
              renderValue={(selected) => (
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                  {selected.map((value) => {
                    return (
                      <Chip
                        key={value}
                        label={getRoleLabel(value)}
                      />
                    );
                  })}
                </Box>
              )}
            >
              {employeePermissions.map((role) => (
                <MenuItem
                  key={role.value}
                  value={role.value}
                >
                  {role.label}
                </MenuItem>
              ))}
            </Select>
          </Grid>
        </Grid>
        {!employeeData?.is_admin && (
          <Stack
            direction={'row-reverse'}
            sx={{ mt: 4 }}
          >
            <Button
              variant='outlined'
              color='error'
              sx={{ width: '20%' }}
              onClick={() => onDelete(data)}
            >
              Delete Employee
            </Button>
          </Stack>
        )}
      </AccordionDetails>
    </Accordion>
  );
};

export default EmployeeDetailCard;
